import React, { useState } from "react";
import { format, addHours } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import DeadlineList from "./DeadlineList";
import triangleDown from "../images/triangle_down.png";
import triangleRight from "../images/triangle_right.png";

const styles = {
  productListItem: {
    width: "100%",
    minHeight: 72,
    margin: "10px 0 5px",
    backgroundColor: "white",
    borderRadius: 5,
    boxShadow: "0px 1px 5px 3px rgba(0, 0, 0, 0.1)",
    padding: "10px 20px",
  },

  productListItemHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
  },

  productListItemName: {
    fontSize: 20,
    fontWeight: "bold",
    textTransform: "capitalize",
  },

  productListItemDate: {
    fontSize: 13,
    textAlign: "left",
  },
};

const ProductItem = ({ isCBOT, product, city, getRates }) => {
  const [isOpen, setIsOpen] = useState(true);
  const hourModifier = isCBOT ? 7 : 0;

  return (
    <li
      style={styles.productListItem}
      onClick={() => setIsOpen(!isOpen)}
      key={product.name}
    >
      <div style={styles.productListItemHeader}>
        <div>
          <p style={styles.productListItemName}>
            {product.name} ({city})
          </p>
          <p style={styles.productListItemDate}>
            {format(
              addHours(new Date(product.lastUpdated), hourModifier),
              "yyyy.MM.dd. kk:mm"
            )}
          </p>

          {isCBOT ? (
            <p style={styles.productListItemDate}>
              (Chicagói idő szerint:{" "}
              {format(new Date(product.lastUpdated), "kk:mm")})
            </p>
          ) : (
            ""
          )}
        </div>
        <div>
          {isOpen ? <img src={triangleDown} /> : <img src={triangleRight} />}
        </div>
      </div>
      {isOpen ? (
        <DeadlineList
          isCBOT={isCBOT}
          deadlines={product.deadlines}
          getRates={getRates}
        />
      ) : (
        ""
      )}
    </li>
  );
};

export default ProductItem;
